import _JSXStyle from "styled-jsx/style";
import React from 'react';
import withDefaults from '../utils/with-defaults';
var defaultProps = {
  className: ''
};

var BreadcrumbsSeparator = function BreadcrumbsSeparator(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "jsx-1610095688" + " " + "separator ".concat(className)
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1610095688"
  }, ".separator.jsx-1610095688{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;margin:0 8px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}"));
};

var MemoBreadcrumbsSeparator = React.memo(BreadcrumbsSeparator);
export default withDefaults(MemoBreadcrumbsSeparator, defaultProps);